import React, { useEffect, useState } from "react";
import { OrderServices } from "../../../core/services/OrderServices";
import { Container, Content, Header, Loader } from "rsuite";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { useNavigate, useParams } from "react-router-dom";
import "./Order.css";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { messageTypeArr } from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { useSelector } from "react-redux";
import RateOrderModal from "./RateOrderModal";
import { Permission } from "./OrderDataTypes";

const UpdateOrderRating = () => {
  const { t } = useTranslation();
  const [loader, setLoading] = useState(false);
  const [openModalByName, setOpenModalByName] = useState("rate-order");
  const params = useParams();
  const navigate = useNavigate();
  let [decryptedParams] = useDecryptedParams(params);
  const company = useSelector((state: any) => state.company);
  const isEditMode = !!decryptedParams.id;
  const permissionObj: Permission = {
    service_rating: true,
  };

  useEffect(() => {
    if (+decryptedParams?.id > 0) {
      // init();
    }
  }, [decryptedParams]);

  async function init() {
    try {
      if (+decryptedParams.id > 0) {
        setLoading(true);

        const response: any = await OrderServices.viewOrder(
          +decryptedParams.id,
        );
      }
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
      navigate(ContentRoutes.ORDERS);
    }
  }

  async function serveOrder(orderId: number, payload: any) {
    try {
      const res: any = await OrderServices.serveOrder(orderId, payload);
      UtilityServices.showToaster({
        message: res?.data?.message,
      });
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  return (
    <div className="order">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      {!loader && (
        <Container className="container">
          <Header className="header">
            <h4>
              {t("UPDATE")} {t("ORDER")} {t("RATING")}
            </h4>
          </Header>
          <Content className="content order-create-wrap mt-3">
            <div className={"usr-tbl-border"}>
              {openModalByName === "rate-order" && +decryptedParams.id > 0 && (
                <RateOrderModal
                  openModal={openModalByName === "rate-order" ? true : false}
                  setOpenModal={setOpenModalByName}
                  orderId={+decryptedParams.id}
                  onServeOrder={serveOrder}
                  permission={permissionObj}
                />
              )}
            </div>
          </Content>
        </Container>
      )}
    </div>
  );
};

export default UpdateOrderRating;
